// these error messages were pulled from https://www.twilio.com/docs/api/errors
//  and the JSON download link provided there
// the errors were filtered by the Programmable Chat product with log_level ERROR
export const twilioErrorMessages = [
  'Programmable Chat: Attributes not valid JSON',
  'Participant proxy address is empty',
  'Participants limit exceeded',
  'Programmable Chat: User channel limit exceeded',
  'Programmable Chat: Invalid consumption interval format',
  'Programmable Chat: User unauthorized to set role',
  'Programmable Chat: Identity too long',
  'Programmable Chat: Invalid webhook format',
  'Global actions per second limit exceeded',
  "Initial state can't be 'closed",
  'Participant projected address not provided',
  'Programmable Chat: Media message body cannot be updated',
  'One user identifier parameter for lookup at a time is allowed. Please, use either Identity or Address.',
  'Programmable Chat: Notification sound name too long',
  'Participant SID not provided',
  'TimeToInactive should be greater or equal to 1 minute',
  'TimeToClosed format is invalid',
  'Conflicting channel modification',
  'Programmable Chat: Webhook call failed to execute successfully',
  'Messaging service SID not provided',
  "Can't update conversation as it's in final closed state",
  'Programmable Chat: Media SID not provided',
  'Programmable Chat: Channel role not found',
  'Programmable Chat: Channel webhook url too long',
  "Type value should be 'private'.",
  'Participant limit exceeded for group conversation',
  "'State' field can't be empty",
  'Programmable Chat: Channel webhook filter not provided',
  "Timer can't be set without state",
  'Non-Chat participants limit exceeded',
  "'State' parameter value is invalid",
  'Group conversation with given participant list already exists',
  'Programmable Chat: User not authorized for command',
  'Programmable Chat: User already exists',
  'Programmable Chat: Channel webhook type not provided',
  'Programmable Chat: Permission not found',
  'Programmable Chat: Invalid Date Updated parameter',
  'Invalid conversation webhook SID',
  'Participant address type does not match proxy address type',
  'Programmable Chat: Author parameter is too long',
  'Conversation webhook trigger not provided',
  'No Messaging Service assigned to Conversation',
  'Failed to remove the projected address of a participant.',
  'Conversation webhook filter not provided',
  'Invalid message media content type',
  'Programmable Chat: Invalid channel webhook flow sid',
  'Identity parameter not acceptable for this Participant',
  'Programmable Chat: Cannot decline invite when already channel member.',
  'Group Participant already exists',
  'Programmable Chat: Service SID not provided',
  'Invalid participant proxy address',
  'Failed to remove the proxy address of a participant.',
  'Conversation SID not provided',
  'Conflicting user modification',
  'Programmable Chat: Role not found',
  'Conversation webhook URL not provided',
  'Programmable Chat: Message index is not a number',
  'Programmable Chat: Identity not provided',
  'Participant and proxy address pair is already in use',
  'Programmable Chat: Invalid typing indicator format',
  ' Message author should be among Group MMS participants.',
  'Conflicting member modification',
  'Account is not authorized to use proxy address',
  'Too many conversation webhook triggers',
  'Programmable Chat: Channel webhook not found',
  'Programmable Chat: User SID not provided',
  'Programmable Chat: Invalid role type',
  'Programmable Chat: Notification template too long',
  'Non-chat conversation participants limit exceeded',
  'Programmable Chat: Friendly name too long',
  'Invalid channel webhook type',
  'Invalid last read message index format',
  'Too many conversation webhooks',
  'Invalid conversation webhook type',
  'Proxy address is not WhatsApp enabled sender',
  'Programmable Chat: User already invited',
  'Programmable Chat: Invite SID not provided',
  'Programmable Chat: Identity reserved',
  'Programmable Chat: Webhook disabled processing of command',
  'Programmable Chat: Channel member limit exceeded',
  'Participant Messaging Binding type does not support all of the provided Messaging Binding parameters',
  'Programmable Chat: Too many channel webhooks',
  'Programmable Chat: Message index not provided',
  'Page token must be bigger than or equal to 0',
  'Programmable Chat: Member SID not provided',
  'Programmable Chat: Media not found',
  'Programmable Chat: Identity should not match user SID pattern',
  'Group MMS activation failed.',
  'Programmable Chat: Attributes too long',
  'TimeToInactive format is invalid',
  'Conversation not found',
  'Programmable Chat: Invalid user channels limit format',
  'Programmable Chat: Channel webhook trigger not provided',
  'Programmable Chat: Channel webhook url not provided',
  'Failed to add a proxy address to a participant.',
  'Conflicting conversation modification',
  'Programmable Chat: Channel creator role not found',
  'Conversation webhook type not provided',
  'User conversation limit exceeded',
  'Message media size is too large',
  'Programmable Chat: Invalid channel webhook trigger',
  'Programmable Chat: Invalid last consumption timestamp format',
  'Programmable Chat: Invalid Account SID',
  'Programmable Chat: Invalid binding type',
  'Programmable Chat: Unique name should not match channel SID pattern',
  'Programmable Chat: Media already sent with another message',
  'Programmable Chat: Parameters are not specified for update request',
  'Programmable Chat: User not member of channel',
  'Invalid messaging service SID',
  'Invalid messaging binding address',
  'Participant already exists',
  'Programmable Chat: User not found',
  'Programmable Chat: Member not found',
  'Participant not found',
  'Invalid conversation webhook flow SID',
  'Programmable Chat: Invalid webhook method',
  'Programmable Chat: Invalid channel members limit format',
  'Programmable Chat: Unique Name too long',
  'Programmable Chat: Channel SID not provided',
  'Programmable Chat: Too many channel webhook triggers',
  'Channel deletion operation is in progress',
  'Programmable Chat: Invalid last consumed message index format',
  'Programmable Chat: Service Instance not found',
  'Conflicting channel modification',
  'Programmable Chat: Message body not provided',
  'Conversation role not found',
  'Programmable Chat: Invalid webhook retry count',
  'Failed to add a projected address to a participant.',
  'Messaging service does not belong to account',
  'Webhook failed to execute successfully due to timeout',
  'Unique name should not match conversation sid pattern',
  'TimeToClosed should be greater or equal to 10 minutes',
  'Invalid conversation webhook trigger',
  'PreWebhookTimeout should be greater than 0ms',
  'Programmable Chat: Message not found',
  'Programmable Chat: Resource is being deleted',
  'Programmable Chat: Invalid Date Created parameter',
  'Programmable Chat: Role SID not provided',
  'Programmable Chat: Message body parameter is too long',
  'Programmable Chat: Channel with provided unique name already exists',
  'Programmable Chat: Channel not found',
  'Participant address equals proxy address',
  'Programmable Chat: Invalid channel webhook filter',
  'Programmable Chat: Member already exists',
  'Programmable Chat: Invalid channel webhook sid',
  'Programmable Chat: Actions per second limit exceeded',
  'Conversation webhook not found',
  'Failed to add an identity to a participant.',
  'Programmable Chat: Unknown channel command',
  'Programmable Chat: Deployment role not found',
  'Participant address is empty',
  'Conversation webhook URL is too long',
  'Participant is not a member of conversation',
  'Programmable Chat: FriendlyName not provided',
  'Programmable Chat: Invite not found',
  'Account is not authorized to use the projected address',
  'Invalid message media SID',
  'Parameters are missing for channel update request',
  'Programmable Chat: Invalid notification level',
  'Programmable Chat: Message SID not provided',
  'Programmable Chat: Account SID not provided',
  'Programmable Chat: Last Updated By parameter is too long',
  'Invalid conversation webhook filter',
  'Programmable Chat: Channel key not provided',
  'Conversations are disabled in this region',
];

export default twilioErrorMessages;
